import React, { useEffect, useState } from "react";
import { Navbar } from "../common/Navbar";
import { Sidebar } from "../common/Sidebar";
import { Col, Container, Row, Spinner, Toast, ToastContainer } from "react-bootstrap";
import img from "../../assets/png/report_ic.png";
import { ReactComponent as SlotCloseIcon } from "../../assets/svg/close-modal.svg";
import DatePicker from "react-datepicker";
import {
  downloadBase64File,
  exportCustomReportApi,
  exportquickApi,
  getquickreportApi,
  getReportAPi,
} from "./report-api";
import "./report.css";
import DateRangePicker from "../common/dateRange";
import { format } from "date-fns";
import CommonDropdown from "../common/common_dropDown";
import { FaRegCalendarAlt } from "react-icons/fa";
import monthly_ticket_ic from "../../assets/svg/monthly_ticket_ic.svg";
import weekly_ticket_ic from "../../assets/svg/weekly_ticket_ic.svg";
import vendor_ticker_ic from "../../assets/svg/vendor_ticker_ic.svg";
import project_based_tic from "../../assets/svg/project_based_tic.svg";
import CommonStaticDropdown from "../common/common_static_dropdown";
const ReportPage = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const [selectedReportType, setSelectedReportType] = useState("QuickReport");
  const [reportStartDate, setReportStartDate] = useState(null);
  const [reportEndDate, setReportEndDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formattedFromDate, setFormattedFromDate] = useState("");
  const [formattedToDate, setFormattedToDate] = useState("");
  const [activeReportLoader, setActiveReportLoader] = useState(-1);

  const [quickReportList, setQuickReportList] = useState([]);

  const [startDateSave, setStartDateSave] = useState(null);
  const [endDateSave, setEndDateSave] = useState(null);
  const [vendorOption, setVendorOption] = useState(null);
  const [paymentTypeOption, setPaymentTypeOption] = useState(null);

  const [poStaOption, setPoStatOption] = useState(null);
  const [payStaOption, setPayStatOption] = useState(null);
  const [transTypeOption, setTransTypeOption] = useState(null);
  const [typeOption, setTypeOption] = useState(null);
  const [fieldOption, setFieldOption] = useState([]);
  const [projectOption, setProjectOption] = useState(null);
  const [productOption, setProductOption] = useState(null);
  const [productGrpOption, setProductGrpOption] = useState(null);
  const [stagesOption, setStagesOption] = useState(null);
  const [gradeOption, setGradeOption] = useState(null);
  const [industryOption, setIndustryOption] = useState(null);
  const [subIndOption, setSubIndOption] = useState(null);
  const [cityOption, setCityOption] = useState(null);
  const [countryOption, setCountryOption] = useState(null);
  const [stateOption, setStateOption] = useState(null);
  const [reportTypeOption, setReportTypeOption] = useState(null);
  const [approverOption, setApproverOption] = useState(null);
  const [dateRange, setDateRange] = useState([null, null]);
  const [from_date, to_date] = dateRange;
  // SnackBar

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const handleDatesChange = (dates) => {
    const [start, end] = dates;
    setReportStartDate(start);
    setReportEndDate(end);

    if (start) {
      setFormattedFromDate(formatDate(start));
    }
    if (end) {
      setFormattedToDate(formatDate(end));
    }
  };
  const handleDateChange = ({ start, end }) => {
    console.log("Selected Start:", start);
    console.log("Selected End:", end);

    const formattedStart = start ? format(start, "yyyy-MM-dd") : null;
    const formattedEnd = end ? format(end, "yyyy-MM-dd") : null;

    console.log("Formatted Start:", formattedStart);
    console.log("Formatted End:", formattedEnd);

    setStartDateSave(formattedStart);
    setEndDateSave(formattedEnd);
  };
  const handleDateClear = () => {
    setReportStartDate(null);
    setReportEndDate(null);
    setFormattedFromDate("");
    setFormattedToDate("");
  };
  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const handleReset = () => {
    setVendorOption(null);
    setProjectOption(null);
    setProductOption(null);
    setProductGrpOption(null);
    setStagesOption(null);
    setGradeOption(null);
    setIndustryOption(null);
    setSubIndOption(null);
    setCityOption(null);
    setCountryOption(null);
    setStateOption(null);
    setPoStatOption(null);
    setPayStatOption(null);
    setTransTypeOption(null);
    setPaymentTypeOption(null);
    setVendorOption(null);
    setDateRange([null, null]);
    setApproverOption(null);
  };
  const handleExport = () => {
    getExcel();
  };

  //Api
  const getReportType = async () => {
    try {
      const response = await getReportAPi();

      if (response.success === true) {
        const suggestions = response.suggestionlist ?? [];

        setReportTypeOption(suggestions); // store all options

        if (suggestions.length > 0) {
          const firstItem = suggestions[0]; // take first index
          setTypeOption(firstItem);
          setFieldOption(firstItem.filters ?? []);
        }
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };

  const exportQuickGet = async (option, index) => {
    if (activeReportLoader === index) return; // ⛔ prevent double click

    setActiveReportLoader(index);

    try {
      console.log(option.value);

      const response = await exportquickApi(
        option.value,
        formattedFromDate,
        formattedToDate,
      );

      console.log(response);

      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.success);
      handleSnackbarShow();

      if (response.status === 200 && response.data.success === true) {
        const base64String = response.data.base64;
        const fileName = response.data.file_name;

        // ✅ Download file
        downloadBase64File(base64String, fileName);
      }
    } catch (error) {
      console.error(error);
      setSnackbarMessage(
        error.response?.data?.message || "Something went wrong.",
      );
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setActiveReportLoader(-1); // ✅ ALWAYS reset loader
    }
  };

  // GetIcon

  const getIconByLabel = (label) => {
    switch (label) {
      case "Monthly Transactions":
      case "Monthly Item-wise Transactions":
      case "Monthly Project-wise Transactions":
      case "Monthly PO-based Transactions":
      case "Monthly Purchase Orders":
      case "Monthly Direct-based Transactions":
        return monthly_ticket_ic;
      case "Weekly Transactions":
      case "Weekly Item-wise Transactions":
      case "Weekly Project-wise Transactions":
      case "Weekly PO-based Transactions":
      case "Weekly Direct-based Transactions":
      case "Weekly Purchase Orders":
        return weekly_ticket_ic;
      case "Vendor Summary":
        return vendor_ticker_ic;
      default:
        return vendor_ticker_ic;
    }
  };
  const getQuickReport = async () => {
    try {
      const response = await getquickreportApi();
      console.log("API response:", response);

      if (response && response.success === true) {
        setQuickReportList(response.suggestionlist);
        console.log("successful");
      } else {
        console.warn("Unexpected response or success flag missing:", response);
      }
    } catch (error) {
      console.error("Error in getquickreport:", error);
    } finally {
    }
  };

  function formatDateToYMD(date) {
    if (!(date instanceof Date)) return "";

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }
  const getExcel = async () => {
    setLoading(true);
    const apiType = typeOption?.value ?? "";
    try {
      const requestBody = {
        from_date: from_date ? formatDateToYMD(from_date) : "",
        to_date: to_date ? formatDateToYMD(to_date) : "",
        vendor_id: vendorOption?.value ?? "",
        product_id: productOption?.value ?? "",
        project_group: productGrpOption?.value ?? "",
        stage: stagesOption?.value ?? "",
        grade_id: gradeOption?.value ?? "",
        sub_industry: subIndOption?.value ?? "",
        industry: industryOption?.value ?? "",
        city_id: cityOption?.value ?? "",
        state_id: stateOption?.value ?? "",
        country_id: countryOption?.value ?? "",
        po_status: poStaOption?.value ?? "",
        trans_type: transTypeOption?.value ?? "",
        payment_type: paymentTypeOption?.value ?? "",
        payment_status: payStaOption?.value ?? "",
        approver_id: approverOption?.value ?? "",
      };

      const response = await exportCustomReportApi(apiType, requestBody);

      if (!response) {
        setSnackbarMessage("Something went wrong.");
        setSnackbarStatus(false);
        handleSnackbarShow();
        return;
      }

      if (response.data.success === true) {
        const base64String = response.data.base64;
        const fileName = "Report_" + new Date().getTime() + ".xlsx";
        downloadBase64File(base64String, fileName);
      }

      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.success);
      handleSnackbarShow();
      /*  setExcel(response.data.url); */
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getQuickReport();
    getReportType();
  }, []);
  return (
    <Container fluid style={{ padding: "0px" }}>
      {" "}
      <div className="d-flex">
        <Sidebar currentfile="Report" />
        <div className=" flex-grow-1 bg-half-white">
          <Navbar pageTitle="Report" />
          <div /* className="maincontent3" */ style={{ marginBottom: "32px" }}>
            <div
              style={{
                /* width: "1171px", */
                /* top: "72px",
                left: "253px", */
                borderRadius: "16px",
                padding: "32px",
                gap: "24px",
                backgroundColor: "#FFFFFF",
                margin: "16px",
              }}
            >
              <Row className="align-items-center">
                <Col sm={12} md={8}>
                  <div style={{ marginTop: "16px" }}>
                    <div style={{ height: "18px" }}>
                      <span
                        style={{
                          fontWeight: "700",
                          fontSize: "24px",
                          lineHeight: "22px",
                          color: "#212129",
                        }}
                      >
                        {selectedReportType === "QuickReport"
                          ? "Quick Report Download"
                          : "Customize your export"}
                      </span>
                    </div>
                    <div style={{ marginTop: "20px" }}>
                      <span
                        style={{
                          fontWeight: "400",
                          fontSize: "14px",
                          lineHeight: "22px",
                          color: "#8790A1",
                        }}
                      >
                        {selectedReportType === "QuickReport" ? (
                          <>
                            Quickly create and save comprehensive reports in
                            just moments. One click is all it takes to access
                            the information you need, whenever you need it!
                          </>
                        ) : (
                          <>
                            Use this customized export option to get your data
                            with your applied filters and manage them easily.
                            Exporting data helps in creating backups.
                          </>
                        )}
                      </span>
                    </div>{" "}
                    <div className="report-inner-content mt-3">
                      <Row className="align-items-center">
                        {/* Left side - report type */}
                        <Col sm={12} md={4} lg={4}>
                          <div className="report-type">
                            <div
                              onClick={() =>
                                setSelectedReportType("QuickReport")
                              }
                              className={`report-type-option ${
                                selectedReportType === "QuickReport"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Quick report
                            </div>
                            <div
                              onClick={() =>
                                setSelectedReportType("Customized")
                              }
                              className={`report-type-option ${
                                selectedReportType === "Customized"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Customized
                            </div>
                          </div>
                        </Col>

                        {/* Spacer column */}
                        <Col />

                        {/* Right side - date range */}
                        <Col
                          sm={12}
                          md={4}
                          lg={4}
                          className="d-flex justify-content-end"
                        >
                          {/* <div className="d-flex justify-content-end mb-2 flex-wrap">
                      <div className="d-flex align-items-center gap-2">
                        <div
                          style={{
                            fontWeight: "500",
                            fontSize: "12px",
                            color: "#172b4d",
                          }}
                          className="d-none d-xl-block"
                        >
                          Date range :
                        </div>
                        <div>
                          <DatePicker
                            selected={reportStartDate}
                            onChange={handleDatesChange}
                            startDate={reportStartDate}
                            endDate={reportEndDate}
                            selectsRange
                            placeholderText="Select date range"
                            className="form-control rounded-3 custom-datepicker"
                            style={{
                              backgroundColor: "#F8F8F8",
                              color: "#8790A1",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                        {reportStartDate && reportEndDate && (
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={handleDateClear}
                          >
                            <SlotCloseIcon />
                          </div>
                        )}
                      </div>
                    </div> */}
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>

                {/* Right Column (Image) */}
                <Col sm={12} md={4} className="text-center">
                  <div
                    style={{
                      // width: "120px",
                      height: "220px",

                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      margin: "0 auto",
                    }}
                  >
                    <img src={img} alt="" style={{ height: "220px" }} />
                  </div>
                </Col>
              </Row>

              {selectedReportType === "QuickReport" && (
                <div>
                  <div className="dotted-divider">
                    <span className="divider-text">
                      Just a single click is enough!
                    </span>
                  </div>
                  {/* Row 1 - Date range on right */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "end",
                      flexWrap: "wrap",
                      gap: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    {/* Date Range */}
                    <div
                      className="d-flex align-items-center px-1"
                      style={{
                        borderRadius: "12px",
                        border: "1px solid #EBEBEB",
                        height: 34,
                        backgroundColor: "white",
                      }}
                    >
                      <span className="fs-12 fw-400 textGrey me-1">
                        Date Range :
                      </span>
                      <span className="dropdown-text1 textPurple">
                        {" "}
                        <DateRangePicker onChange={handleDateChange} />
                      </span>
                    </div>
                  </div>
                  {/* Row 2 - Quick report list */}
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "12px",
                      marginBottom: "24px",
                    }}
                  >
                    {quickReportList.map((item, index) => (
                      <div
                        key={index}
                        onClick={() => exportQuickGet(item, index)}
                        style={{
                          cursor:
                            activeReportLoader === index
                              ? "not-allowed"
                              : "pointer",
                          display: "flex",
                          gap: "12px",
                          alignItems: "center",
                          borderRadius: "16px",
                          padding: "12px",
                          border: "0.7px solid #F8F8F8",
                          backgroundColor: "#F8F8F8",
                          width: "calc(25% - 9px)",
                          boxSizing: "border-box",
                          opacity: activeReportLoader === index ? 0.7 : 1,
                          pointerEvents:
                            activeReportLoader === index ? "none" : "auto",
                        }}
                      >
                        {activeReportLoader === index ? (
                          <>
                            <Spinner animation="border" size="sm" />
                            <div className="fs-14 fw-500 textcolor">
                              Loading...
                            </div>
                          </>
                        ) : (
                          <>
                            <div>
                              <img
                                src={getIconByLabel(item.label)}
                                style={{ width: "20px" }}
                                alt=""
                              />
                            </div>
                            <div className="fs-14 fw-500 textcolor">
                              {item.label}
                            </div>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {selectedReportType === "Customized" && (
                <div>
                  <Row
                    xs={12}
                    className="w-100"
                    style={{ display: "flex", flexWrap: "wrap" }}
                  >
                    <Col sm={12} md={6} lg={4} style={{ marginTop: "16px" }}>
                      <h1
                        style={{
                          fontWeight: "500",
                          fontSize: "13px",
                          lineHeight: "17.55px",
                          color: "#212129",
                        }}
                      >
                        Type
                      </h1>
                      <CommonDropdown
                        apiUrl={`${apiUrl}report/get_report_type?type=Customized`}
                        placeholder="Select"
                        value={typeOption}
                        onSelect={(item) => {
                          setTypeOption(item);
                          setFieldOption(item.filters ?? []);
                          handleReset();
                          console.log("fieldOption", fieldOption);
                        }}
                      />
                    </Col>{" "}
                    {fieldOption.includes("PO Status") && (
                      <Col sm={12} md={6} lg={4} style={{ marginTop: "16px" }}>
                        <h1
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                          }}
                        >
                          PO Status
                        </h1>
                        <CommonStaticDropdown
                          items={[
                            {
                              value: "Draft",
                              label: "Draft",
                            },
                            { value: "Confirmed", label: "Confirmed" },
                            { value: "cancelled", label: "Cancelled" },
                          ]}
                          placeholder="Select"
                          value={poStaOption}
                          enableSearch={false}
                          onSelect={(item) => {
                            setPoStatOption(item);
                          }}
                        />
                      </Col>
                    )}
                    {fieldOption.includes("Payment Status") && (
                      <Col sm={12} md={6} lg={4} style={{ marginTop: "16px" }}>
                        <h1
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                          }}
                        >
                          Payment Status
                        </h1>
                        <CommonStaticDropdown
                          items={[
                            {
                              value: "Pending",
                              label: "Pending",
                            },
                            {
                              value: "Partially-Paid",
                              label: "Partially-Paid",
                            },
                            { value: "Paid", label: "Paid" },
                          ]}
                          placeholder="Select"
                          value={payStaOption}
                          enableSearch={false}
                          onSelect={(item) => {
                            setPayStatOption(item);
                          }}
                        />
                      </Col>
                    )}
                    {fieldOption.includes("Transaction type") && (
                      <Col sm={12} md={6} lg={4} style={{ marginTop: "16px" }}>
                        <h1
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                          }}
                        >
                          Transaction type
                        </h1>
                        <CommonStaticDropdown
                          items={[
                            { value: "Direct", label: "Direct" },
                            { value: "PO based", label: "PO based" },
                          ]}
                          placeholder="Select"
                          value={transTypeOption}
                          enableSearch={false}
                          onSelect={(item) => {
                            setTransTypeOption(item);
                          }}
                        />
                      </Col>
                    )}
                    {fieldOption.includes("Payment type") && (
                      <Col sm={12} md={6} lg={4} style={{ marginTop: "16px" }}>
                        <h1
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                          }}
                        >
                          Payment type
                        </h1>
                        <CommonDropdown
                          apiUrl={`${apiUrl}get_payment_type`}
                          placeholder="Select"
                          value={paymentTypeOption}
                          onSelect={(item) => {
                            setPaymentTypeOption(item);
                          }}
                        />
                      </Col>
                    )}
                    {fieldOption.includes("Vendor") && (
                      <Col sm={12} md={6} lg={4} style={{ marginTop: "16px" }}>
                        <h1
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                          }}
                        >
                          Vendor
                        </h1>
                        <CommonDropdown
                          apiUrl={`${apiUrl}get_vendor`}
                          placeholder="Select"
                          value={vendorOption}
                          onSelect={(item) => {
                            setVendorOption(item);
                          }}
                        />
                      </Col>
                    )}
                    {fieldOption.includes("Project") && (
                      <Col sm={12} md={6} lg={4} style={{ marginTop: "16px" }}>
                        <h1
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                          }}
                        >
                          Project
                        </h1>
                        <CommonDropdown
                          apiUrl={`${apiUrl}get_project`}
                          placeholder="Select"
                          value={projectOption}
                          onSelect={(item) => {
                            setProjectOption(item);
                          }}
                        />
                      </Col>
                    )}
                    {fieldOption.includes("Product") && (
                      <Col sm={12} md={6} lg={4} style={{ marginTop: "16px" }}>
                        <h1
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                          }}
                        >
                          Product
                        </h1>
                        <CommonDropdown
                          apiUrl={`${apiUrl}get_product`}
                          placeholder="Select"
                          value={productOption}
                          onSelect={(item) => {
                            setProductOption(item);
                          }}
                        />
                      </Col>
                    )}
                    {fieldOption.includes("Product group") && (
                      <Col sm={12} md={6} lg={4} style={{ marginTop: "16px" }}>
                        <h1
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                          }}
                        >
                          Product Group
                        </h1>
                        <CommonDropdown
                          apiUrl={`${apiUrl}get_product`}
                          placeholder="Select"
                          value={productGrpOption}
                          onSelect={(item) => {
                            setProductGrpOption(item);
                          }}
                        />
                      </Col>
                    )}
                    {fieldOption.includes("Stage") && (
                      <Col sm={12} md={6} lg={4} style={{ marginTop: "16px" }}>
                        <h1
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                          }}
                        >
                          Stage
                        </h1>
                        <CommonDropdown
                          apiUrl={`${apiUrl}get_vendor_stage`}
                          placeholder="Select"
                          value={stagesOption}
                          onSelect={(item) => {
                            setStagesOption(item);
                          }}
                        />
                      </Col>
                    )}
                    {fieldOption.includes("Grade") && (
                      <Col sm={12} md={6} lg={4} style={{ marginTop: "16px" }}>
                        <h1
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                          }}
                        >
                          Grade
                        </h1>
                        <CommonDropdown
                          apiUrl={`${apiUrl}get_grade`}
                          placeholder="Select"
                          value={gradeOption}
                          onSelect={(item) => {
                            setGradeOption(item);
                          }}
                        />
                      </Col>
                    )}
                    {fieldOption.includes("Industry") && (
                      <Col sm={12} md={6} lg={4} style={{ marginTop: "16px" }}>
                        <h1
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                          }}
                        >
                          Industry
                        </h1>
                        <CommonDropdown
                          apiUrl={`${apiUrl}get_industry`}
                          placeholder="Select"
                          value={industryOption}
                          onSelect={(item) => {
                            setIndustryOption(item);
                          }}
                        />
                      </Col>
                    )}
                    {fieldOption.includes("Sub industry") && (
                      <Col sm={12} md={6} lg={4} style={{ marginTop: "16px" }}>
                        <h1
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                          }}
                        >
                          Sub Industry
                        </h1>
                        <CommonDropdown
                          apiUrl={`${apiUrl}get_sub_industry?industry_id=${
                            industryOption?.value ?? ""
                          }`}
                          placeholder="Select"
                          value={subIndOption}
                          onSelect={(item) => {
                            setSubIndOption(item);
                          }}
                        />
                      </Col>
                    )}
                    {fieldOption.includes("City") && (
                      <Col sm={12} md={6} lg={4} style={{ marginTop: "16px" }}>
                        <h1
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                          }}
                        >
                          City
                        </h1>
                        <CommonDropdown
                          apiUrl={`${adminUrl}get_city`}
                          placeholder="Select"
                          value={cityOption}
                          onSelect={(item) => {
                            setCityOption(item);
                          }}
                        />
                      </Col>
                    )}
                    {fieldOption.includes("State") && (
                      <Col sm={12} md={6} lg={4} style={{ marginTop: "16px" }}>
                        <h1
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                          }}
                        >
                          State
                        </h1>
                        <CommonDropdown
                          apiUrl={`${adminUrl}get_state`}
                          placeholder="Select"
                          value={stateOption}
                          onSelect={(item) => {
                            setStateOption(item);
                          }}
                        />
                      </Col>
                    )}
                    {fieldOption.includes("Country") && (
                      <Col sm={12} md={6} lg={4} style={{ marginTop: "16px" }}>
                        <h1
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                          }}
                        >
                          Country
                        </h1>
                        <CommonDropdown
                          apiUrl={`${adminUrl}get_country`}
                          placeholder="Select"
                          value={countryOption}
                          onSelect={(item) => {
                            setCountryOption(item);
                          }}
                        />
                      </Col>
                    )}
                    {fieldOption.includes("Approver") && (
                      <Col sm={12} md={6} lg={4} style={{ marginTop: "16px" }}>
                        <h1
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                          }}
                        >
                          Approver
                        </h1>
                        <CommonDropdown
                          apiUrl={`${adminUrl}get_user`}
                          placeholder="Select"
                          value={approverOption}
                          onSelect={(item) => {
                            setApproverOption(item);
                          }}
                        />
                      </Col>
                    )}
                    {fieldOption.includes("Date range") && (
                      <Col sm={12} md={6} lg={4} style={{ marginTop: "16px" }}>
                        <h1
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                          }}
                        >
                          {typeOption?.label === "Transaction" || typeOption?.value === "transaction_report" ? "Date Range(Transaction Date)" : "Date Range"}
                        </h1>
                        <div
                          style={{ position: "relative", width: "100%" }}
                          className="react-datepicker-wrapper"
                        >
                          <DatePicker
                            // className="custom-date"
                            selectsRange={true}
                            startDate={from_date}
                            endDate={to_date}
                            onChange={(update) => setDateRange(update)}
                            className="react-datepicker__input-container textcolor"
                            style={{
                              width: "100%",
                            }}
                            placeholderText="Select"
                            wrapperClassName="w-100"
                          />
                          <FaRegCalendarAlt
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              pointerEvents: "none",
                              color: "#8790A1",
                            }}
                          />
                        </div>
                      </Col>
                    )}{" "}
                    <Col
                      sm={12}
                      lg={12}
                      className="d-flex justify-content-end align-items-center pt-5"
                    >
                      <button
                        style={{
                          width: "126px",
                          height: "44px",
                          borderRadius: "8px",
                          border: "0.6px solid #E5E5E5",
                          backgroundColor: "#FFFFFF",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={handleReset}
                      >
                        <p style={{ margin: 0 }}>Reset</p>
                      </button>

                      <button
                        style={{
                          width: "126px",
                          height: "44px",
                          borderRadius: "8px",
                          color: "#FFFFFF",
                          border: "0.6px solid #E5E5E5",
                          backgroundColor: "#6929E2",
                          marginLeft: "8px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={handleExport}
                        disabled={loading} // disable while loading
                      >
                        {loading ? (
                          <div
                            style={{
                              width: "20px",
                              height: "20px",
                              border: "2px solid #fff",
                              borderTop: "2px solid transparent",
                              borderRadius: "50%",
                              animation: "spin 1s linear infinite",
                            }}
                          />
                        ) : (
                          <p style={{ margin: 0 }}>Export</p>
                        )}

                        <style>
                          {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
                        </style>
                      </button>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          {/*  <Toast.Header>
                  <strong className="mr-auto">Snackbar Title</strong>
                </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
};

export default ReportPage;
